import { IEvent } from "@eagerdog/interfaces";

/**
 * Tiny module-level bus so the publish paths (PublishEventModal, EventForm)
 * can ask for the "Share to feed" modal without threading props through
 * their many call sites. ShareToFeedModalHost (mounted once in App) listens.
 */
type Listener = (event: IEvent) => void;

const listeners = new Set<Listener>();

export const requestShareToFeed = (event: IEvent): void => {
    listeners.forEach((fn) => fn(event));
};

export const subscribeShareToFeed = (fn: Listener): (() => void) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
};
